import { useCallback } from 'react'

const REDIRECT_URL_KEY = 'odin_redirect_url'

export const useRedirectUrl = () => {
  const saveRedirectUrl = useCallback((url: string) => {
    if (url && url !== '/' && !url.includes('change-password')) {
      sessionStorage.setItem(REDIRECT_URL_KEY, url)
    }
  }, [])

  const getRedirectUrl = useCallback((): string => {
    const savedUrl = sessionStorage.getItem(REDIRECT_URL_KEY)
    if (savedUrl) {
      return savedUrl
    }

    const currentSearch = window.location.search
    return currentSearch ? `/orders${currentSearch}` : '/orders'
  }, [])

  const clearRedirectUrl = useCallback(() => {
    sessionStorage.removeItem(REDIRECT_URL_KEY)
  }, [])

  return {
    saveRedirectUrl,
    getRedirectUrl,
    clearRedirectUrl
  }
}
